/* eslint-disable */
import ObjectHelper from './object-helper';

export default class UrlHelper {
    /**
     * Builds query string by passed key-value object and concatenates it properly to the origin url
     * @param url
     * @param params
     * @param defaultParams
     * @returns {string}
     */
    static getUrlByParams(url, params, defaultParams = {}) {
        const paramsPrefix = url.indexOf('?') === -1 ? '?' : '&';
        const paramsString = UrlHelper.getQueryStringByParams(params, defaultParams);
        return `${url}` + (paramsString !== '' ? `${paramsPrefix}${paramsString}` : '');
    }

    /**
     * Build query string by the passed key-value object of the query parameters
     * The particular parameter won't be present in the final query string if its current value is equal to its default value from defaultParams
     * @param params
     * @param defaultParams
     * @returns {string}
     */
    static getQueryStringByParams(params, defaultParams = {}) {
        const searchableParams = this.getSearchableParams(params, defaultParams);
        return this.param(searchableParams);
    }

    /**
     * Filter params object by removing particular parameter if it has the value that is equal to its default value from defaultParams
     * @param params
     * @param defaultParams
     * @returns {{}}
     */
    static getSearchableParams(params, defaultParams = {}) {
        const result = {};
        for (const i in params) {
            if (!(i in defaultParams) || !this.isParametersValuesEqual(params[i], defaultParams[i])) {
                result[i] = params[i];
            }
        }
        return result;
    }

    static isParametersValuesEqual(parameter1, parameter2) {
        if (
            (Array.isArray(parameter1) && !Array.isArray(parameter2)) ||
            (!Array.isArray(parameter1) && Array.isArray(parameter2)) ||
            (ObjectHelper.isObject(parameter1) && !ObjectHelper.isObject(parameter2)) ||
            (!ObjectHelper.isObject(parameter1) && ObjectHelper.isObject(parameter2))
        ) {
            throw new Error('one of the arguments is Array or Object and another is not');
        } else if (
            (Array.isArray(parameter1) && Array.isArray(parameter2)) ||
            (ObjectHelper.isObject(parameter1) && ObjectHelper.isObject(parameter2))
        ) {
            return ObjectHelper.isEqual(parameter1, parameter2);
        }
        return parameter1 === parameter2;
    }

    /**
     * Returns the object of the query parameters of the passed location
     * @param location
     * @returns {*}
     */
    static getSearchFromLocation(location) {
        return this.getParamsFromQueryString(location.search.substring(1));
    }

    /**
     * Split the passed query string and returns key-value object of get parameters
     * @param queryString
     * @returns {{}}
     */
    static getParamsFromQueryString(queryString) {
        const str = queryString.replace(/\/$/, '') || '';
        const result = {};
        const parsedQueryParameters = [];

        str.split('&').forEach((keyValue) => {
            if (keyValue) {
                let value = keyValue.split('=');
                const key = decodeURIComponent(value[0]);
                value = value[1] ? decodeURIComponent(value[1]) : '';
                parsedQueryParameters.push([key, value]);
            }
        });
        parsedQueryParameters.forEach(([key, value]) => ObjectHelper.addToAssociativeCollection(result, key, value));

        return result;
    }

    /**
     * Returns the value of the passed parameter name of the passed location.
     * Return null if paramName isn't present in the location's query string
     *
     * @param paramName
     * @param location
     * @returns {*}
     */
    static getParamFromLocation(paramName, location) {
        const params = this.getSearchFromLocation(location);
        if (paramName in params) {
            return params[paramName];
        }

        return null;
    }

    static getFullUrlWithAppliedParams(location, applyParams) {
        const params = this.getSearchFromLocation(location);

        const finalParams = {};
        const mergedParams = { ...params, ...applyParams };
        for (const key in mergedParams) {
            if (mergedParams[key] !== undefined && mergedParams[key] !== null) {
                finalParams[key] = mergedParams[key];
            }
        }

        return `${location.origin}${this.getUrlByParams(location.pathname, finalParams)}${location.hash}`;
    }

    static getRelativeUrl(location) {
        return `${location.pathname}${location.search}${location.hash}`;
    }

    /**
     jQuery param
     */
    static param(params) {
        const s = [];
        const add = function (k, v) {
            v = typeof v === 'function' ? v() : v;
            v = v === null ? '' : v === undefined ? '' : v;
            s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
        };
        var buildParams = function (prefix, obj) {
            let i,
                len,
                key;

            if (prefix) {
                if (Array.isArray(obj)) {
                    for (i = 0, len = obj.length; i < len; i++) {
                        buildParams(
                            prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i : i) + ']',
                            obj[i]
                        );
                    }
                } else if (String(obj) === '[object Object]') {
                    for (key in obj) {
                        buildParams(prefix + '[' + key + ']', obj[key]);
                    }
                } else {
                    add(prefix, obj);
                }
            } else if (Array.isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    add(obj[i].name, obj[i].value);
                }
            } else {
                for (key in obj) {
                    buildParams(key, obj[key]);
                }
            }
            return s;
        };

        return buildParams('', params).join('&');
    }

    /**
     jQuery deparam is an extraction of the deparam method from Ben Alman's jQuery BBQ
     http://benalman.com/projects/jquery-bbq-plugin/
     */
    static deparam(params, coerce = true) {
        let obj = {},
            coerce_types = { true: !0, false: !1, null: null };

        // Iterate over all name=value pairs.
        params.replace(/\+/g, ' ').split('&').forEach((v) => {
            let param = v.split('='),
                key = decodeURIComponent(param[0]),
                val,
                cur = obj,
                i = 0,

                // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
                // into its component parts.
                keys = key.split(']['),
                keys_last = keys.length - 1;

            // If the first keys part contains [ and the last ends with ], then []
            // are correctly balanced.
            if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
                // Remove the trailing ] from the last keys part.
                keys[keys_last] = keys[keys_last].replace(/\]$/, '');

                // Split first keys part into two parts on the [ and add them back onto
                // the beginning of the keys array.
                keys = keys.shift().split('[').concat(keys);

                keys_last = keys.length - 1;
            } else {
                // Basic 'foo' style key.
                keys_last = 0;
            }

            // Are we dealing with a name=value pair, or just a name?
            if (param.length === 2) {
                val = decodeURIComponent(param[1]);

                // Coerce values.
                if (coerce) {
                    val = val && !isNaN(val) ? +val // number
                        : val === 'undefined' ? undefined // undefined
                            : coerce_types[val] !== undefined ? coerce_types[val] // true, false, null
                                : val; // string
                }

                if (keys_last) {
                    // Complex key, build deep object structure based on a few rules:
                    // * The 'cur' pointer starts at the object top-level.
                    // * [] = array push (n is set to array length), [n] = array if n is
                    //   numeric, otherwise object.
                    // * If at the last keys part, set the value.
                    // * For each keys part, if the current level is undefined create an
                    //   object or array based on the type of the next keys part.
                    // * Move the 'cur' pointer to the next level.
                    // * Rinse & repeat.
                    for (; i <= keys_last; i++) {
                        key = keys[i] === '' ? cur.length : keys[i];
                        cur = cur[key] = i < keys_last
                            ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : [])
                            : val;
                    }
                } else {
                    // Simple key, even simpler rules, since only scalars and shallow
                    // arrays are allowed.

                    if (Array.isArray(obj[key])) {
                        // val is already an array, so push on the next value.
                        obj[key].push(val);
                    } else if (obj[key] !== undefined) {
                        // val isn't an array, but since a second value has been specified,
                        // convert val into an array.
                        obj[key] = [obj[key], val];
                    } else {
                        // val is a scalar.
                        obj[key] = val;
                    }
                }
            } else if (key) {
                // No value was defined, so set something meaningful.
                obj[key] = coerce
                    ? undefined
                    : '';
            }
        });

        return obj;
    }

    /**
     * Return url with additional flag that makes the server interpret the desired page as a partial
     * without head, scripts, styles, meta and so on.
     * Usually helpful when we want to embed the whole page without refreshing current one.
     */
    static getOverlayUrl(url) {
        return UrlHelper.getUrlByParams(url, { overlay: "true" });
    }
}
